import Banner from "./components/Banner";
import Notification from "./components/Notification";
import Project from "./components/Project";

const ProfileOverview = () => {
  return (
    <div  className="col-span-4 lg:!mb-0 mt-4 block rounded-lg rounded-full bg-gradient-to-b from-white/50 to-white/10">
      <div className="w-ful mt-3 flex h-fit flex-col gap-5 lg:grid lg:grid-cols-12">
        <div className="col-span-5 lg:!mb-0">
          <Banner />
            <div className="col-span-5 lg:col-span-6 lg:mb-0 3xl:col-span-4">
          <Project />
        </div>
        </div>
         <div className="col-span-5 lg:col-span-20 lg:mb-0 3xl:!col-span-7 col-span-5 lg:col-span-22 lg:mb-0 3xl:!col-span-7 "
         >
          
          <Notification />
        </div>
      </div>
      {/* all project & ... */}


    </div>
  );
};

export default ProfileOverview;
